import React from 'react';
import {StyleSheetManager} from './StyleSheetManager.eager';

export const ConditionalStyleSheetManager: React.FC<
  React.PropsWithChildren<{isRTL: boolean}>
> = ({children, isRTL}) => {
  if (isRTL) {
    return <StyleSheetManager>{children}</StyleSheetManager>;
  }
  return <>{children}</>;
};
